import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { productService } from "./productService";

export const getAllProducts = createAsyncThunk(
  "product/get",
  async (data,thunkAPI) => {
    try {
      return await productService.getProducts(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);


export const getRelatedProducts = createAsyncThunk(
  "product/getRelatedProducts",
  async (productSlug, thunkAPI) => {
    try {
      const response = await productService.getRelatedProducts(productSlug);
      return response;
    } catch (error) {
      console.error("Error fetching related products:", error);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

 
  


export const getAProduct = createAsyncThunk(
  "product/getAProduct",
  async (slug,thunkAPI) => {
    try {
      return await productService.getSingleProduct(slug);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
 

 
const productState = {
  product: [],
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",
  relatedProducts: [],
  ratings: [],
  singleproduct: null, 

};

export const productSlice = createSlice({
  name: "product",
  initialState: productState,
  reducers: {  
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllProducts.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllProducts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.product = action.payload;
      })
      .addCase(getAllProducts.rejected, (state, action) => {
        state.isError = true;
        state.isLoading = false;
        state.isSuccess = false;
        state.message = action.error;
      })
 
 
      .addCase(getAProduct.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAProduct.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.singleproduct = action.payload;
        state.message = "Product Fetched Successfully !";
      })
      .addCase(getAProduct.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      }) 
 
     .addCase(getRelatedProducts.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getRelatedProducts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.relatedProducts = action.payload;
        state.message = "Related Products Fetched Successfully!";

      })
      .addCase(getRelatedProducts.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
 
     
     
  },
});

 
export default productSlice.reducer;

